import { render, staticRenderFns } from "./SortList.vue?vue&type=template&id=602e636a&"
import script from "./SortList.vue?vue&type=script&lang=js&"
export * from "./SortList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports